export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.10.19-1500.02",
  commitId: "25d52f24039242553b5b9ad05bcdd7a0c597fd49",
  commitTime: "2026-10-19T15:00:02.000Z",
});
